import { useTranslation } from "react-i18next";
import useStyleUtils from "../../../utilities/styles";
import IPasswordFormProps from "../IPasswordFormProps";
import { Col, Row } from "react-grid-system";
import TextArea from "../../../components/formFields/textArea/TextArea";
import { Button, MessageBar, MessageBarBody, Text } from "@fluentui/react-components";
import { Add12Filled, Delete16Filled } from "@fluentui/react-icons";
import TextField from "../../../components/formFields/textField/TextField";
import IMFAToken from "../../../models/password/IMFAToken";

const newToken = (): IMFAToken => ({
    name: '',
    token: ''
});

export const PersonalMessage = () => {
    const { t } = useTranslation();

    return (
        <MessageBar>
            <MessageBarBody>
                {t("passwords.form.fields.audienceTargeting.personal")}
            </MessageBarBody>
        </MessageBar>
    );
};

export default function MFATab(props: IPasswordFormProps) {
    const { t } = useTranslation();

    const style = useStyleUtils();

    const handleAddToken = () => {
        const tokens = [...props.data.mfa!.tokens, newToken()];
        props.onChange('mfa.tokens', tokens);
    };

    const handleEditToken = (index: number, field: string, value: string) => {
        const tokens = [...props.data.mfa!.tokens];
        tokens[index] = { ...tokens[index], [field]: value };
        props.onChange('mfa.tokens', tokens);
    };

    const handleDeleteToken = (index: number) => {
        const tokens = [...props.data.mfa!.tokens];
        tokens.splice(index, 1);
        props.onChange('mfa.tokens', tokens);
    }

    return (
        <Row>
            <Col>
                <div className={style.mb3}>
                    <TextArea
                        label={t("passwords.form.fields.mfaNotes.label")}
                        value={props.data.mfa?.notes}
                        onChange={(value) => props.onChange('mfa.notes', value)}
                        placeholder={t("passwords.form.fields.mfaNotes.placeholder")}
                        />
                </div>

                <div className={`${style.dFlex} ${style.w100} ${style.alignItemsCenter}`}>
                    <Text>{t("passwords.form.fields.tokenList.header")}</Text>
                    <Button icon={<Add12Filled />} className={style.mlAuto} onClick={handleAddToken} />
                </div>
                {
                    props.data.mfa!.tokens.map((_, index) => (
                        <Row align="end" className={style.mb3}>
                            <Col xs={12} md={6} lg={4}>
                                <TextField required
                                    type='text'
                                    label={t("passwords.form.fields.tokenList.fields.name.label")}
                                    value={props.data.mfa!.tokens[index].name}
                                    onChange={(value) => handleEditToken(index, 'name', value)}
                                    placeholder={t("passwords.form.fields.tokenList.fields.name.placeholder")}
                                    />
                            </Col>
                            <Col>
                                <TextField required
                                    type='password'
                                    label={t("passwords.form.fields.tokenList.fields.token.label")}
                                    value={props.data.mfa!.tokens[index].token}
                                    onChange={(value) => handleEditToken(index, 'token', value)}
                                    placeholder={t("passwords.form.fields.tokenList.fields.token.placeholder")}
                                    />
                            </Col>
                            <Col xs="content">
                                <Button icon={<Delete16Filled />} style={{ color: "red" }} onClick={() => handleDeleteToken(index)} />
                            </Col>
                        </Row>
                    ))
                }
            </Col>
        </Row>
    );
}